module.exports = __webpack_public_path__ + "media/images/countrysquared/fm-2eda46d19c009073d0af95c0c215ca85.svg";